import { render } from "./MealPlans.vue?vue&type=template&id=7e70ede0&ts=true"
import script from "./MealPlans.vue?vue&type=script&lang=ts"
export * from "./MealPlans.vue?vue&type=script&lang=ts"

import "./MealPlans.vue?vue&type=style&index=0&id=7e70ede0&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__